<template>
  <div id="subject-count">
    <FreeAccessCelebration
      v-if="showFreeAccessCelebration"
      :free-access="accountStatus.freeAccess"
      :user-id="freeAccessUserId"
      :approval="accountStatus.approval"
    />
    <account-onboarding-status
      v-if="accountStatus"
      :account="accountStatus"
      surface="dashboard"
      class="mb-2"
    />
    <b-row class="d-flex justify-content-center">
      <!-- <Congratulation /> -->
    </b-row>
    <!-- Stats Card Vertical -->
    <b-row class="match-height">
      <b-col xl="3" md="3" sm="6">
        <b-link
          :to="{
            name: 'clientlist',
            params: { sort: 'program.active=true&active=true' },
          }"
        >
          <statistic-card-vertical
            icon="UserCheckIcon"
            :statistic="stats.activeSubjectCount || 0"
            color="success"
            id="subject-count-card"
            :statistic-title="$t('Active Subject Count')"
          />
        </b-link>
      </b-col>
      <b-col xl="3" md="3" sm="6">
        <b-link
          :to="{
            name: 'clientlist',
            params: { sort: 'program.active=false&active=true' },
          }"
        >
          <statistic-card-vertical
            color="warning"
            icon="UserIcon"
            :statistic="stats.onHoldSubjectCount || 0"
            :statistic-title="$t('On Hold Subject Count')"
          />
        </b-link>
      </b-col>
      <b-col xl="3" md="3" sm="6">
        <b-link
          :to="{
            name: 'clientlist',
            params: { sort: 'active=false' },
          }"
        >
          <statistic-card-vertical
            color="warning"
            icon="UserMinusIcon"
            :statistic="stats.passiveSubjectCount || 0"
            :statistic-title="$t('Passive Subjects')"
          />
        </b-link>
      </b-col>
      <b-col xl="3" md="3" sm="6">
        <b-link
          :to="{
            name: 'clientlist',
            params: {
              sort: `program.exercisesPrinted={'gt':'program.exercisesDone'}`,
            },
          }"
        >
          <statistic-card-vertical
            :color="stats.exerciseCount > 24 ? 'danger' : 'warning'"
            icon="FileTextIcon"
            :statistic="stats.exerciseCount || 0"
            :statistic-title="$t('Exercises Awaiting Result')"
          />
        </b-link>
      </b-col>
      <!-- <b-col xl="2" md="4" sm="6">
                <statistic-card-vertical
                  :color="this.stats.testCount > 0 ? 'success' : 'danger'"
                  icon="ZapIcon"
                  :statistic="this.stats.testCount"
                  statistic-title="Kalan Diko Hakkı"
                />
              </b-col>

              <b-col xl="2" md="4" sm="6">
                <statistic-card-vertical
                  color="primary"
                  icon="HeartIcon"
                  statistic="Diko Test"
                  statistic-title=" ile 124 Saat"
                />
              </b-col>
              <b-col xl="2" md="4" sm="6">
                <statistic-card-vertical
                  hide-chart
                  color="danger"
                  icon="AlertOctagonIcon"
                  :statistic="this.stats.testCount"
                  statistic-title="Kalan Test Hakkı"
                />
              </b-col> -->
    </b-row>
    <!-- <b-row> -->
    <!-- <b-card class="w-100" style="height: 10px"> -->
    <!-- <span
                style="background-color: #34bde6"
                :style="{
                  width: `${
                    successData.change < 0
                      ? successData.score + successData.change
                      : successData.score
                  }%`,
                }"
              >
                {{ successData.score }}%
              </span>
              <span
                :style="{
                  'min-width': `${Math.abs(successData.change)}%`,
                  'background-color': `${
                    successData.change < 0 ? 'rgba(234, 84, 85,0.75)' : 'rgba(40, 199, 111,0.75)'
                  }`,
                }"
              >
                {{ successData.change }}%
              </span> -->
    <b-card>
      <h4 style="text-align: center">{{ $t("Overall Success") }}</h4>
      <SuccessBar
        :pausedState="true"
        :transition="true"
        :score="successData.score"
        :change="successData.change"
      />
    </b-card>
    <!-- </b-card> -->
    <!-- </b-row> -->
    <b-row class="d-flex justify-content-center match-height mt-2">
      <!-- <b-col xl="4">
                <CardAnalyticGoalOverview />
              </b-col> -->
      <b-col xl="6">
        <!-- <statistic-card-with-bar-chart
                  icon="TrendingUpIcon"
                  statistic="?"
                  statistic-title="Danışan Genel Durum"
                  :chart-data="seriesComputed"
                  :chart-options="optionsComputed"
                  color="success"
                /> -->
        <slot>
          <PastTimeline :refresh="analyticsRefresh" />
        </slot>
        <!-- <h4 class="mt-3" style="text-align: center">Danışanların Genel Durumu</h4> -->
        <!-- <vue-apex-charts
                  height="500"
                  width="100%"
                  :options="optionsComputed"
                  :series="seriesComputed"
                /> -->
      </b-col>
      <b-col xl="6">
        <slot>
          <ApproachingTimeline :refresh="analyticsRefresh" />
        </slot>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FreeAccessCelebration from '@/components/FreeAccessCelebration.vue'
import { isFreeAccessActive } from '@/libs/freeAccess'
import {
  BRow,
  BCol,
  BLink,
  BCard,
} from "bootstrap-vue";
import StatisticCardVertical from "@core/components/statistics-cards/StatisticCardVertical.vue";
import Congratulation from "./Congratulation.vue";
import CardAnalyticGoalOverview from "./CardAnalyticGoalOverview.vue";
import StatisticCardWithBarChart from "./StatisticCardWithBarChart.vue";
import ApproachingTimeline from "./ApproachingTimeline.vue";
import PastTimeline from "./PastTimeline.vue";
import axios from "@axios";

import SuccessBar from "./SuccessBar.vue";
import AccountOnboardingStatus from '@/components/AccountOnboardingStatus.vue'
import { mergeApprovalLifecycleAccount } from '@/libs/approvalLifecycle'
import {
  fetchSubscriptionStanding,
  SUBSCRIPTION_STANDING_INVALIDATED_EVENT,
} from '@/libs/subscriptionStanding'
// import chartOpts from "./barChartOptions.js";
import VueApexCharts from "vue-apexcharts";
import Ripple from "vue-ripple-directive";
// import userStatistic from "./userStatistic.js";
const {
  axiosRoutes: { auth: path, user: userPath },
} = require("/G_CONFIG");

export default {
  components: {
    FreeAccessCelebration,
    BRow,
    BCol,
    BLink,
    BCard,
    StatisticCardVertical,
    Congratulation,
    CardAnalyticGoalOverview,
    StatisticCardWithBarChart,
    ApproachingTimeline,
    PastTimeline,
    VueApexCharts,
    SuccessBar,
    AccountOnboardingStatus,
  },
  directives: {
    Ripple,
  },
  computed: {
    freeAccessUserId() {
      return (this.accountStatus && (Reflect.get(this.accountStatus, '_id') || this.accountStatus.id)) || ''
    },
    showFreeAccessCelebration() {
      const account = this.accountStatus
      return Boolean(account && this.freeAccessUserId && account.approvalStanding
        && account.approvalStanding.reason === 'approved' && account.canUseGatedFeatures
        && isFreeAccessActive(account.freeAccess))
    },
    successData() {
      console.log(this.chartData);
      return this.chartData;
    },
    analyticsRefresh() {
      return this.analyticsrefresh + this.manualRefresh;
    },
  },
  watch: {
    // analyticsrefresh(newVal, oldVal) {
    // },
  },
  //   seriesComputed() {
  //     return this.chartData.series;
  //   },
  //   optionsComputed() {
  //     return { ...chartOpts, ...this.barChartOptions };
  //   },
  // },
  props: {
    analyticsrefresh: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      // barChartOptions: chartOpts,
      stats: {
        activeSubjectCount: 0,
        exerciseCount: 0,
        subjectCount: 0,
        testCount: 0,
      },
      manualRefresh: 0,
      chartData: { change: 0, total: 0 },
      accountStatus: null,
      accountStatusRequest: null,
      accountStatusRefreshTimer: null,
      accountStatusRefreshQueued: false,
      accountStatusRefreshActive: true,
      //   series: [
      //     {
      //       name: "",
      //       data: [],
      //     },
      //     {
      //       name: "ARTIŞ",
      //       data: [],
      //       color: $themeColors.success,
      //     },
      //     {
      //       name: "DÜŞÜŞ",
      //       data: [],
      //       color: $themeColors.danger,
      //     },
      //   ],
      // },
    };
  },
  mounted() {
    if (typeof window !== 'undefined') {
      window.addEventListener(
        SUBSCRIPTION_STANDING_INVALIDATED_EVENT,
        this.scheduleAccountStatusRefresh,
      )
      window.addEventListener('focus', this.scheduleAccountStatusRefresh)
    }
    if (typeof document !== 'undefined') {
      document.addEventListener('visibilitychange', this.refreshVisibleAccountStatus)
    }
    this.loadAccountStatus({ forceRefresh: true })
    axios.get(path.dashboardStats).then((fetched) => {
      // console.log(fetched.data);
      // this.barChartOptions.xaxis = {
      //   ...this.barChartOptions.xaxis,
      //   categories: fetched.data.chartData.names,
      //   overwriteCategories: fetched.data.chartData.names,
      // };
      this.stats.activeSubjectCount = fetched.data.activeSubjectCount;
      this.stats.exerciseCount = fetched.data.exerciseCount;
      this.stats.activeSubjectCount = fetched.data.activeSubjectCount;
      this.stats.onHoldSubjectCount = fetched.data.onHoldSubjectCount;
      this.stats.passiveSubjectCount = fetched.data.passiveSubjectCount;
      // this.chartData.series = [
      //   { name: "", data: fetched.data.chartData.scores },
      //   {
      //     name: "ARTIŞ",
      //     data: fetched.data.chartData.increase,
      //     color: $themeColors.success,
      //   },
      //   {
      //     name: "DÜŞÜŞ",
      //     data: fetched.data.chartData.decrease,
      //     color: $themeColors.danger,
      //   },
      // ]; /*fetched.data.series;*/
      this.chartData = fetched.data.chartData;
    });
    /* console.log(this.stats.activeSubjectCount, "activeSubjectCount") */
    this.interval = setInterval(() => {
      this.rerenderAnalytics();
      this.loadAccountStatus({ forceRefresh: true })
    }, 60000);
  },
  beforeDestroy() {
    this.accountStatusRefreshActive = false
    if (typeof window !== 'undefined') {
      window.removeEventListener(
        SUBSCRIPTION_STANDING_INVALIDATED_EVENT,
        this.scheduleAccountStatusRefresh,
      )
      window.removeEventListener('focus', this.scheduleAccountStatusRefresh)
    }
    if (typeof document !== 'undefined') {
      document.removeEventListener('visibilitychange', this.refreshVisibleAccountStatus)
    }
    if (this.accountStatusRefreshTimer) clearTimeout(this.accountStatusRefreshTimer)
    clearInterval(this.interval);
  },
  methods: {
    scheduleAccountStatusRefresh() {
      if (this.accountStatusRequest) {
        this.accountStatusRefreshQueued = true
        return
      }
      if (this.accountStatusRefreshTimer) clearTimeout(this.accountStatusRefreshTimer)
      this.accountStatusRefreshTimer = setTimeout(() => {
        this.accountStatusRefreshTimer = null
        this.loadAccountStatus({ forceRefresh: true })
      }, 0)
    },
    refreshVisibleAccountStatus() {
      if (typeof document === 'undefined' || document.visibilityState === 'visible') {
        this.scheduleAccountStatusRefresh()
      }
    },
    loadAccountStatus({ forceRefresh = false } = {}) {
      if (this.accountStatusRequest) {
        if (forceRefresh) this.accountStatusRefreshQueued = true
        return this.accountStatusRequest
      }
      const request = axios.get(userPath.my).then(({ data }) => fetchSubscriptionStanding({ forceRefresh })
        .then(standing => {
          this.accountStatus = mergeApprovalLifecycleAccount(data, standing)
        })
        .catch(() => {
          this.accountStatus = mergeApprovalLifecycleAccount(data)
        }))
      this.accountStatusRequest = request
      return request.finally(() => {
        if (this.accountStatusRequest === request) this.accountStatusRequest = null
        if (this.accountStatusRefreshQueued
          && this.accountStatusRefreshActive) {
          this.accountStatusRefreshQueued = false
          this.scheduleAccountStatusRefresh()
        }
      })
    },
    rerenderAnalytics() {
      console.log("rerenderAnalytics");
      this.manualRefresh++;
    },
  },
};
</script>
<style lang="scss"></style>
